<div class="min-h-screen bg-gray-100 p-6">
  <div class="max-w-screen mx-auto bg-white rounded-xl shadow-md p-6">

    <div class="flex justify-between items-center mb-4">
      <h1 class="text-2xl font-bold text-gray-900 leading-tight">Sales History</h1>

      <!-- Total -->
      <div class="bg-blue-50 text-blue-700 font-semibold px-4 py-2 rounded-lg shadow-sm">
        Total Sale: 119.98
      </div>
    </div>

    <input
      type="text"
      placeholder="Search..."
      class="w-full border border-gray-300 rounded-lg px-4 py-2 mb-4 focus:ring-2 focus:ring-blue-500 focus:outline-none"
    />

    <div class="overflow-x-auto">
      <table class="w-full border border-gray-200 rounded-lg overflow-hidden">
        <thead class="bg-gray-100 text-gray-700 font-semibold">
          <tr>
            <th class="px-4 py-3 border-b">Date</th>
            <th class="px-4 py-3 border-b">Customer</th>
            <th class="px-4 py-3 border-b">Product</th>
            <th class="px-4 py-3 border-b">Amount</th>
          </tr>
        </thead>

        <tbody class="text-gray-800">
          <tr class="border-b">
            <td class="px-4 py-3">April 21, 2024</td>
            <td class="px-4 py-3">John Doe</td>
            <td class="px-4 py-3">Ring</td>
            <td class="px-4 py-3">79.99</td>
          </tr>

          <tr class="bg-gray-50 border-b">
            <td class="px-4 py-3">April 20, 2024</td>
            <td class="px-4 py-3">Jane Smith</td>
            <td class="px-4 py-3">Bracelet</td>
            <td class="px-4 py-3">39.99</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
